import AlertIcon from "@repo/ui/src/components/Icons/AlertIcon";

const ErrorState = ({ text }: { text?: string }) => {
  if (!text) return null;

  return (
    <div className="tw-flex tw-gap-2 tw-py-5 tw-px-6 tw-bg-red-100 tw-border-red-400 tw-border-2">
      <AlertIcon className="tw-w-5 tw-h-5 tw-shrink-0" />
      <p className="tra-text-web-body-m">{text}</p>
    </div>
  );
};

export default ErrorState;
